import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import Breadcrumb from '../components/AdminBreadcrumb';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import SchoolIcon from '@mui/icons-material/School';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import GrantIcon from '@mui/icons-material/LocalAtmRounded';
import MultilineChart from '@mui/icons-material/MultilineChart';

export const AdminMenu = (props) => {
    return (
        <Container>
            <Breadcrumb history={props.history} />
            <Row className='d-flex justify-content-center' xs="1">
                <Col xs='6' lg='3' className="admin-list-box d-flex justify-content-center align-items-center" onClick={() => { props.history.push('/sessions') }}><CalendarTodayIcon className='align-bottom pe-1' />Session Years</Col>
                <Col xs='6' lg='3' className="admin-list-box d-flex justify-content-center align-items-center" onClick={() => { props.history.push('/projects') }}><AssignmentRoundedIcon className='align-bottom pe-1' />Projects</Col>
                {/*<Col xs='6' lg='3' className="admin-list-box d-flex justify-content-center align-items-center" onClick={() => { props.history.push('/courses') }}><LocalLibraryIcon className='align-bottom pe-1' />Courses</Col>*/}
                {/*<Col xs='6' lg='3' className="admin-list-box d-flex justify-content-center align-items-center" onClick={() => { props.history.push('/sections') }}><LocalLibraryIcon className='align-bottom pe-1' />Sessions</Col>*/}
                <Col
                    xs='6'
                    lg='3'
                    className="admin-list-box d-flex justify-content-center align-items-center"
                    onClick={() => {
                        props.history.push({
                            pathname: '/grants',
                            state: { myProp: 'fromMenu' }
                        });
                    }}
                >
                    <GrantIcon className='align-bottom pe-1' />
                    Grants
                </Col>
                <Col xs='6' lg='3' className="admin-list-box d-flex justify-content-center align-items-center" onClick={() => { props.history.push('/jurisdictions') }}><AssignmentRoundedIcon className='align-bottom pe-1' />Jurisdictions</Col>
                {props.isAdmin && <Col xs='6' lg='3' className="admin-list-box d-flex justify-content-center align-items-center" onClick={() => { props.history.push('/users') }}><PeopleOutlineIcon className='align-bottom pe-1' />Users</Col>}
                <Col xs='6' lg='3' className="admin-list-box d-flex justify-content-center align-items-center" onClick={() => { props.history.push('/contactlist') }}><PeopleOutlineIcon className='align-bottom pe-1' />Contacts</Col>
                {/*<Col xs='6' lg='3' className="admin-list-box d-flex justify-content-center align-items-center" onClick={() => { props.history.push('/trainingTypes') }}><SchoolIcon className='align-bottom pe-1' />Training Types</Col>*/}
                {/*<Col xs='6' lg='3' className="admin-list-box d-flex justify-content-center align-items-center" onClick={() => { props.history.push('/reports') }}><MultilineChart className='align-bottom pe-1' />Reports</Col>*/}
            </Row>
        </Container>
    )
}